<template>
    <integration />
</template>

<script>
    import Integration from './Integration.vue';

    export default {
        name: 'integration-container',
        components: {
            Integration,
        }
    }
</script>


// WEBPACK FOOTER //
// IntegrationContainer.vue?aec2e90a